/**
 * Finds the index of the closest value.
 *
 * When multiple values share the minimum distance and are coincident (same
 * value), prefers the last index if the target is at or to the right of the
 * stack, and the first index if to the left. Equidistant but different values
 * still return the first index.
 *
 * @param {Array<number>} values - Array of numbers to search through.
 * @param {number} value - The target value to find the closest match for.
 * @returns {number} The index of the closest value in the array.
 */
export const indexOfClosest = (values: Array<number>, value: number) => {
  if (values.length === 1) return 0;
  const distances = values.map((n) => Math.abs(n - value));
  const minDistance = Math.min(...distances);
  const first = distances.indexOf(minDistance);
  const last = distances.lastIndexOf(minDistance);
  if (first === last) return first;
  // Coincident handles: prefer max when target is at/right of stack, min when left
  if (values[first] === values[last]) {
    return value >= values[first] ? last : first;
  }
  // Equidistant but different values: keep existing first-wins behavior
  return first;
};
